export function createPermalink(map, view, {
  encodeLayers,
  decodeLayers,
}) {
  let shouldUpdate = true

  const update = () => {
    if (!shouldUpdate) {
      shouldUpdate = true
      return
    }

    const center = view.getCenter()

    const hash = '#map='
      + view.getZoom() + '/'
      + Math.round(center[0] * 100) / 100 + '/'
      + Math.round(center[1] * 100) / 100 + '/'
      + view.getRotation() + '/'
      + encodeLayers()

    window.history.pushState(
      {
        zoom: view.getZoom(),
        center: view.getCenter(),
        rotation: view.getRotation(),
      },
      'map',
      hash,
    )
  }

  const onPopState = (event) => {
    if (!event.state) return

    view.setCenter(event.state.center)
    view.setZoom(event.state.zoom)
    view.setRotation(event.state.rotation)
    decodeLayers(map, event.state.layers)
    shouldUpdate = false
  }

  return {
    update,
    onPopState,
  }
}
